/*
 * Pure CSV parser for the results-list editor, extracted verbatim from
 * components/article/edit.js (the inline `parseCSV` closure) so it can be
 * unit tested and reused by the feed composer's slash command.
 *
 * This is a faithful extraction, not a rewrite: delimiter auto-detection,
 * header-row skipping, and the club/country column heuristics keep every
 * original quirk (including a few surprising ones - see
 * tests/lib/resultsCsv.test.js for the documented edge cases) so the
 * existing admin tool's behaviour does not change.
 */

export function parseResultsCsv(text) {
    const lines = text.split('\n').filter(l => l.trim());
    if (lines.length === 0) return [];
    // Auto-detect delimiter
    const firstLine = lines[0];
    const tabCount = (firstLine.match(/\t/g) || []).length;
    const semiCount = (firstLine.match(/;/g) || []).length;
    const delimiter = tabCount >= semiCount ? '\t' : ';';
    let startIdx = 0;
    // Auto-detect header: if first cell is NaN, skip first row
    const firstCell = lines[0].split(delimiter)[0].trim();
    if (isNaN(firstCell) && firstCell !== '') {
        startIdx = 1;
    }
    const entries = [];
    for (let i = startIdx; i < lines.length; i++) {
        const cols = lines[i].split(delimiter).map(c => c.trim());
        if (cols.length < 2) continue;
        const entry = {
            position: parseInt(cols[0], 10) || (i - startIdx + 1),
            name: cols[1] || '',
            result: cols[2] || '',
        };
        // Remaining columns: detect club vs country
        for (let c = 3; c < cols.length; c++) {
            const val = cols[c];
            if (!val) continue;
            if (/^[A-Z]{2}$/.test(val) && !entry.country) {
                entry.country = val;
            } else if (!entry.club) {
                entry.club = val;
            } else if (!entry.country) {
                entry.country = val;
            }
        }
        entries.push(entry);
    }
    return entries;
}
